import FormModal from '../../Components/FormModal'
import textIcon from '@/assets/quick-img/text-icon.png'
import { Radio, Spin, Select } from '@arco-design/web-react';
const RadioGroup = Radio.Group;
const { Option } = Select;
import styles from './choose.module.less';
import React, {useEffect, useState, MouseEvent} from 'react';
import emptyImg from "@/assets/quick-img/no-data-min.png";
import { Message } from '@arco-design/web-react';
import {getScriptRepoApi} from "@/services/quickcut";
import moment from "moment/moment";
import {getScriptRepoDetail, getScriptRepoWord} from "@/services/copyWriter";
import {convertStringToJson} from "@/utils";
import quickCutStore from '@/stores/quickCutStore'
import QuickCutStore from "@/stores/quickCutStore";
import { observer } from "mobx-react";
const ChooseTextModal = (props) => {
  const { visible, handCancel, emitChange, closeHot, activeIndex, onShowHot = true } = props;
  const [active, setActive] = useState(1);
  const [list, setList] = useState([]);
  const [checkedId, setCheckId] = useState(null);
  const [activeObj, setActiveObj] = useState({});
  const [loading, setLoading] = useState(false);
  const [need_content, setNeed_content] = useState(false);
  const [textList, setTextList] = useState([]);
  const [variableObj, setVariableObj] = useState({
    key: undefined,
    title: ''
  });
  const [options, setOptions] = useState([
    {
      value: 1,
      label: '组合文案',
    },
    {
      value: 2,
      label: '智能文案',
    },
    {
      value: 3,
      label: '爆款解说',
    },
  ]);

  useEffect(() => {
    if (visible) {
      if (closeHot) {
        const data = options.slice(0, 2)
        setOptions(data)
        setActive(1)
        getList(1, false);
      }
      if (onShowHot) {
        const data = options.filter(item => item.value === 3)
        setOptions([...data])
        setActive(3)
        getList(3, true);
      }
    } else {
      setOptions([
        {
          value: 1,
          label: '组合文案',
        },
        {
          value: 2,
          label: '智能文案',
        },
        {
          value: 3,
          label: '爆款解说',
        },
      ])
      setActive(1)
      getList(1, false);
    }
  }, [visible]);

  const submitHandle = () => {
    if (!checkedId) {
      Message.warning('请选择文案');
      return;
    }
    console.log(variableObj, '提交数据')
    emitChange(activeObj, checkedId, variableObj)
  }


  const getList = (active, flag) => {
    setLoading(true);
    setList([])
    getScriptRepoApi({
      type: active,
      need_content: flag,
    }).then(res => {
      setLoading(false);
      const data = res.data.items || [];
      setList(data);
      if (QuickCutStore.quickcutData.global) { // 全局
        if (QuickCutStore.quickcutData.settings.copy.copy_id) {
          setCheckId(QuickCutStore.quickcutData.settings.copy.copy_id);
        }
      } else {
        if (QuickCutStore.quickcutData.scenes[activeIndex]?.settings?.copy?.copy_id) {
          setCheckId(QuickCutStore.quickcutData.scenes[activeIndex]?.settings?.copy.copy_id);
          if (QuickCutStore.quickcutData.scenes[activeIndex]?.settings?.copy?.variable_key) {
            getDetails(QuickCutStore.quickcutData.scenes[activeIndex]?.settings?.copy?.copy_id);
          }
        }
      }
    }).catch(e => {
      setLoading(false);
    })
  }
  const getDetails = async(id) => {
    try {
      const resDetail = await getScriptRepoDetail(id);
      if (resDetail.code == 0 && resDetail?.data?.item) {
        const { content } = resDetail.data.item;
        if (content) {
          const data = JSON.parse(content);
          setTextList(data.list || [])
          if (QuickCutStore.quickcutData.scenes[activeIndex]?.settings?.copy?.variable_key) {
            setVariableObj({
              key: QuickCutStore.quickcutData.scenes[activeIndex]?.settings?.copy.variable_key,
              title: QuickCutStore.quickcutData.scenes[activeIndex]?.settings?.copy.variable_name,
            })
          }
        }
      }
    } catch (error) {
      console.log("error===========>", error);
    }
  }
  return (
    <div>
      <FormModal submitHandle={submitHandle} handCancel={handCancel} title={'文案库'} icon={textIcon} width={650} visible={visible}>
        <div className={styles['text-content']}>
          <RadioGroup
            options={options}
            type='button'
            defaultValue={1}
            value={active}
            onChange={(value) => {
              setActive(value);
              if (value === 3) {
                // setNeed_content(true);
                getList(value, true);
              } else {
                // setNeed_content(false);
                getList(value, false);
              }
            }}
            style={{ marginBottom: 11 }}
          />
          <div className={styles['text-list']}>
            {
              list && list.filter(item => item?.count > 0 && item?.available_count > 0 ).map((item) => {
                return (
                  <div key={item.id} onClick={(e: MouseEvent<HTMLDivElement>) => {
                    // 如果点击的是 Select 组件，不执行点击事件
                    const target = e.target as HTMLElement;
                    if (target.closest('.arco-select')) {
                      return;
                    }
                    setCheckId(item.id);
                    setActiveObj(item);
                    // 只有在切换不同项时才清空 variableObj
                    if (checkedId !== item.id) {
                      setVariableObj({
                        key: null,
                        title: ''
                      });
                      setTextList([]);
                    }
                  }} className={`${styles['text-li']} ${checkedId === item.id ? styles['active'] : ''}`}>
                    <div className={styles['title']}>
                      <div>{ item.name }</div>
                      {
                        active === 3 && !quickCutStore.quickcutData.global && checkedId === item.id && <Select
                              placeholder="展开更多"
                              allowClear
                              style={{ width: 100, height: 34 }}
                              onClick={() => {
                                getDetails(item.id);
                              }}
                              value={variableObj.key}
                              onChange={(value) => {
                                if (!value) {
                                  // 清空选择
                                  setVariableObj({
                                    key: null,
                                    title: ''
                                  });
                                  return;
                                }
                                const obj = textList.find(i => i.key === value);
                                if (obj) {
                                  setVariableObj({
                                    key: obj.key,
                                    title: obj.title
                                  });
                                }
                              }}
                          >
                          {textList?.length > 0 && textList?.map((option, index) => (
                            <Option key={index} value={option.key}>
                              {`${option.title}`}
                            </Option>
                          ))}
                          </Select>
                      }
                    </div>
                    <div className={styles['number-time']}>
                      <div>{ item?.available_count || 0 } / { item?.count || 0 }</div>
                      <div>{ moment
                        .unix(item.updated_at)
                        .format("YYYY-MM-DD HH:mm") }</div>
                    </div>
                  </div>
                )
              })
            }
            {
              !loading && list?.length === 0 && <div className={styles['no-data']}>
                    <img src={emptyImg} alt=""/>
                    <div className={styles['data-info']}>暂无数据</div>
                </div>
            }
            {
              loading && <Spin className={styles['spin']} size={20} />
            }
          </div>
        </div>
      </FormModal>
    </div>
  )
}
export default observer(ChooseTextModal);
